import React, { useEffect, useState } from "react";
import axios from "axios";
import URL from "../config/API";

function UpdateProfile() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  const getProfile = async () => {
    try {
      const res = await axios.get(`${URL.BASE_URL}/profile`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setName(res.data.name);
      setEmail(res.data.email);
    } catch (error) {
      console.error("❌ Fetch profile error:", error.response?.data || error.message);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.put(
        `${URL.BASE_URL}/profile`,
        { name },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert(res.data.message);
    } catch (error) {
      console.error("❌ Update error:", error.response?.data || error.message);
      alert("Update failed");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProfile();
  }, []);

  return (
    <div className="container">
      <h2>Update Profile</h2>
      <form onSubmit={handleUpdate}>
        <label>Name</label>
        <input value={name} onChange={(e) => setName(e.target.value)} />

        <label>Email</label>
        <input value={email} disabled />

        <button disabled={loading}>
          {loading ? "Updating..." : "Update Profile"}
        </button>
      </form>
    </div>
  );
}

export default UpdateProfile;
